import { z } from "zod";
/** Analytics event names (AGENTS.md 9.4). Events never carry answer values or personal data. */
export const EVENT_TYPES = [
    // loader
    "button_view",
    "button_click",
    "widget_close",
    "page_view_after_open",
    // chat
    "widget_resume",
    "consent_shown",
    "consent_accepted",
    "consent_declined",
    "node_shown",
    "node_answered",
    "answer_edited",
    "help_opened",
    "step_completed",
    "form_completed",
    "upload_started",
    "upload_completed",
    "upload_failed",
    "whatsapp_click",
    "booking_click",
    "external_booking_open",
    "badge_click",
    // Phase 2
    "slot_selected",
    "payment_started",
    "payment_succeeded",
    "payment_failed",
    "booking_confirmed",
    // server / dashboard
    "lead_abandoned",
    "pa_whatsapp_open",
    "stage_changed",
    "reminder_sent",
    "escalation_sent",
];
export const eventTypeSchema = z.enum(EVENT_TYPES);
//# sourceMappingURL=events.js.map